/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";

import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import notificationState from "../../states/notificationState";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import { debounce } from "lodash";
import CustomerMaterialButton from "../input/CustomerMaterialButton";
/**
 * @COMPONENT_NAME CustomerMaterial
 * @DESCRIPTION 고객의 자재 정보 중 1:1로 매칭되는 다른 상품코드와 상품명을 관리하는 화면입니다.
 *              이 화면에서는 자재의 생성, 수정, 삭제가 가능합니다.
 * @PROPS
	  - 없음
 * @PASSTHROUGH_PROPS
 *   - {string} id - "CustomerMaterial";
 *   - {string} view - "VwCustomerMaterial"
 *   - {string} table - "CustomerMaterial"
 * @CALLBACKS
 *	  - {Function} onApiInitialized - API 초기화 시 호출되는 콜백 함수
 *	  - {Function} onInitialized - grid 초기화 시 호출되는 콜백 함수
 *	  - {Function} onSuccess - 성공 시 호출되는 콜백 함수
 *	  - {Function} onFailure - 실패 시 호출되는 콜백 함수
 *	  - {Function} onNotifyWarning - 경고 메시지 표시 시 호출되는 콜백 함수
 * 
 */

function CustomerMaterial(props) {
	const id = "CustomerMaterial";

	const [schema, setSchema] = useState();
	const [api, setApi] = useState();
	const [grid, setGrid] = useState();
	const [selectGrid, setSelectGrid] = useState();

	const setNotification = useSetRecoilState(notificationState);
	useEffect(() => {
		let mounted = true;
		async function schemaSetting() {
			let schema = await getSchema("CustomerMaterial");
			if (mounted) {
				setSchema(schema);
			}
		}

		schemaSetting();

		return () => {
			mounted = false;
		};
	}, []);

	useEffect(() => {
		(async () => {
			if (grid) {
				grid.selectionChanged.addHandler(
					debounce((grid, event) => {
						if (grid.selectedItems && grid.selectedItems[0]) {
							setSelectGrid(grid.selectedItems[0]);
						} else {
							setSelectGrid(undefined);
						}
					}, 10)
				);

				grid.itemsSourceChanged.addHandler(
					debounce((grid, event) => {
						if (grid.selectedItems && grid.selectedItems[0]) {
							setSelectGrid(grid.selectedItems[0]);
						} else {
							setSelectGrid(undefined);
						}
					}, 10)
				);
			}
		})();
	}, [grid]);

	const onApiInitialized = (api) => {
		setApi(api);
	};

	const onInitialized = (grid) => {
		setGrid(grid);
	};

	const notifySuccess = (msg) => {
		setNotification({
			severity: "success",
			msg: msg,
			open: true,
		});
	};

	const notifyWarning = (msg) => {
		setNotification({
			severity: "warning",
			msg: msg,
			open: true,
		});
	};

	const notifyFailure = (msg) => {
		setNotification({
			severity: "error",
			msg: msg,
			open: true,
		});
	};
	const onSuccess = (msg) => {
		notifySuccess(msg);
		if (api) {
			api.refresh();
		}
	};

	const onFailure = (reason) => {
		notifyFailure(reason);
	};

	const onNotifyWarning = (msg) => {
		notifyWarning(msg);
		if (api) {
			api.refresh();
		}
	};
	const modifyFormDataCallback = (formData) => {
		formData.custUnitId = formData.custUnitId || null;
	}
	return (
		<BasicCrudScreenType
			id="CustomerMaterial"
			table="CustomerMaterial"
			view="VwCustomerMaterial"
			onApiInitialized={onApiInitialized}
			onInitialized={onInitialized}
			noCreate
			noEdit
			noDelete
			noExcel
			onAppendButtonInFrontOfSearch={() => (
				<>
					<BasicCrudScreenActionItemLayout>
						<AccessControl
							accessTarget={schema && schema.name}
							accessMethod="POST"
						>
							<CustomerMaterialButton
								id={id}
								schema={schema}
								refresh={api}
								onSuccess={onSuccess}
							/>
						</AccessControl>
						<AccessControl
							accessTarget={schema && schema.name}
							accessMethod={
								schema &&
								(schema.updateWithPatch ? "PATCH" : "PUT")
							}
						>
							<UpdateRecordButton
								id={id}
								schema={schema}
								grid={grid}
								refresh={api}
								disabled={selectGrid ? false : true}
								onSuccess={onSuccess}
								modifyFormDataCallback={modifyFormDataCallback}
							/>
						</AccessControl>
						<AccessControl
							accessTarget={schema && schema.name}
							accessMethod="DELETE"
						>
							<DeleteRecordButton
								id={id}
								schema={schema}
								grid={grid}
								refresh={api}
								color="secondary"
								onSuccess={onSuccess}
								onFailure={onFailure}
								onPartialFailure={onNotifyWarning}
								disabled={selectGrid ? false : true}
							/>
						</AccessControl>
					</BasicCrudScreenActionItemLayout>
				</>
			)}
		/>
	);
}

export default CustomerMaterial;
